import { i18n } from '@lingui/core';

export interface EditBinderDeliveryPageParams extends Record<string, string | undefined> {
  projectId: string
  binderDelivery: string;
}
export const ROUTE_PARAM_IDENTIFIER = ':projectId';
export const BINDER_DELIVERY_PARAM_IDENTIFIER = ':binderDelivery';
export const ROUTE_PATH = `/projects/${ROUTE_PARAM_IDENTIFIER}/binder-deliveries/${BINDER_DELIVERY_PARAM_IDENTIFIER}`;
export const TITLE = i18n._('Edit Binder Delivery');
